import PhrasesApplicationListLayer from "../../components/PhrasesApplicationListLayer";

const PhraseApplicationPage = () => {
  return <PhrasesApplicationListLayer />;
};

export default PhraseApplicationPage;
